import React, { Component } from 'react';
import { Flame, Check, Clock } from 'lucide-react';
import { combos } from '../data/combos';
import { WA_NUMBER } from '../data/products';
import { WhatsAppIcon } from './icons/WhatsAppIcon';
export function CombosSection() {
  return <section className="bg-dark-900 py-[80px] px-5" id="combos" data-id="element-66">
      <div className="max-w-[1100px] mx-auto" data-id="element-67">
        <h2 className="text-[2.2rem] font-black text-center mb-2.5 uppercase tracking-[2px] text-white flex items-center justify-center gap-3" data-id="element-68">
          <Flame className="w-8 h-8 text-alphaGold" data-id="element-69" /> COMBOS ESPECIALES
        </h2>
        <p className="text-center text-[#aaa] mb-[50px] text-[1.05rem]" data-id="element-70">
          Combinaciones diseñadas para maximizar tus resultados al mejor precio
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-[30px]" data-id="element-71">
          {combos.map(combo => <div key={combo.id} className="bg-dark-800 border border-dark-500 rounded-xl overflow-hidden transition-all duration-300 hover:border-alphaGold hover:-translate-y-2 hover:shadow-[0_10px_30px_rgba(212,160,23,0.15)] flex flex-col" data-id="element-72">
              <div className="relative bg-white h-52 flex items-center justify-center p-1 overflow-hidden" data-id="element-73">
                <div className="absolute top-3 left-3 bg-alphaGold text-dark-900 text-xs font-black px-3 py-1.5 rounded-full uppercase tracking-wider z-10 shadow-md" data-id="element-74">
                  🔥 COMBO ESPECIAL
                </div>
                <img src={combo.image} alt={combo.name} className="max-w-full max-h-full object-contain scale-110" data-id="element-75" />
              </div>

              <div className="p-6 flex flex-col flex-grow" data-id="element-76">
                <h3 className="text-xl font-black text-white mb-4 uppercase tracking-wide" data-id="element-77">
                  {combo.name}
                </h3>

                <ul className="space-y-2 mb-4" data-id="element-78">
                  {combo.products.map((product, idx) => <li key={idx} className="flex items-start gap-2 text-[#ddd] text-sm font-medium" data-id="element-79">
                      <Check className="w-4 h-4 text-alphaGold shrink-0 mt-0.5" data-id="element-80" />
                      <span data-id="element-81">{product}</span>
                    </li>)}
                </ul>

                <p className="text-[#888] text-sm italic mb-3" data-id="element-82">
                  "{combo.pain}"
                </p>

                <p className="text-[#bbb] text-sm mb-6 flex-grow" data-id="element-83">
                  {combo.benefit}
                </p>

                <div className="border-t border-dark-500 pt-5 mb-5" data-id="element-84">
                  <div className="flex items-end gap-3 mb-2" data-id="element-85">
                    <span className="text-3xl font-black text-alphaGold" data-id="element-86">
                      ${combo.comboPrice.toLocaleString('es-UY')}
                    </span>
                    <span className="text-lg text-[#666] line-through font-bold mb-1" data-id="element-87">
                      ${combo.individualPrice.toLocaleString('es-UY')}
                    </span>
                  </div>
                  <div className="inline-block bg-green-900/30 border border-green-500/50 text-green-400 text-xs font-bold px-2.5 py-1 rounded" data-id="element-88">
                    AHORRÁS ${combo.savings.toLocaleString('es-UY')} vs
                    individual
                  </div>
                </div>

                <a href={`https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(combo.waMessage)}`} target="_blank" rel="noopener noreferrer" className="w-full bg-[#25D366] hover:bg-[#1ebe5d] text-white font-bold py-3.5 px-4 rounded-lg flex items-center justify-center gap-2 transition-colors duration-300 mb-4" data-id="element-89">
                  <WhatsAppIcon className="w-5 h-5" data-id="element-90" />
                  LO QUIERO AHORA
                </a>

                <div className="flex items-center justify-center gap-1.5 text-alphaGold text-xs font-bold uppercase tracking-wider" data-id="element-91">
                  <Clock className="w-3.5 h-3.5" data-id="element-92" />
                  Stock limitado — Solo por tiempo limitado
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}